import { Box, Flex, Icon } from '@chakra-ui/react';
import * as T from '../../components/Table';
import { FaWhatsapp } from 'react-icons/fa';
import { Telefone } from './components/Telefone';

export function ModalItem({ item }) {
  return (
    <T.Tr>
      <T.Td>{item.nome_cliente}</T.Td>
      <T.Td>{item.telefone_parceiro}</T.Td>
      <T.Td>{item.celular_parceiro}</T.Td>
      <T.Td>{item.email_contato}</T.Td>
      <T.Td>
        <Flex gap={2} alignItems="center" justifyContent="center">
          <Box as={item?.link_whats ? 'a' : 'div'} href={item.link_whats} target="_blank">
            <Icon
              as={FaWhatsapp}
              color={item?.link_whats ? '#25D366' : 'red.500'}
              fontSize="20px"
              _hover={{
                cursor: 'pointer',
                transform: 'scale(1.1)'
              }}
              transition="all 0.2s"
            />
          </Box>
          <Telefone {...item} />
        </Flex>
      </T.Td>
    </T.Tr>
  );
}
